import axios from "axios";
import api_endpoints from "./backendroutes";

export const apiRequestHandler = async ({
  method = "GET",
  endPoint,
  data = {},
  params = {},
  headers = {},
}) => {
  try {
    const response = await axios({
      method,
      url: api_endpoints[endPoint] || endPoint,
      data: ["POST", "PUT", "PATCH", "DELETE"].includes(method.toUpperCase()) ? data : undefined,
      params: method.toUpperCase() === "GET"|| method.toUpperCase() === "POST" ? params : undefined,
      headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,

      },
    });

    return response.data;
  } catch (error) {
    return error.response?.data || { success: false, message: "Network Error" };
  }
};
